import avatarRetina from 'marketing-website/media/images/pages/features/handoff/avatar@2x.jpg';
import blackRetina from 'marketing-website/media/images/pages/features/handoff/black@2x.png';
import fillsRetina from 'marketing-website/media/images/pages/features/handoff/fills@2x.png';
import imageOneRetina from 'marketing-website/media/images/pages/features/handoff/imageOne@2x.png';
import imageThreeRetina from 'marketing-website/media/images/pages/features/handoff/imageThree@2x.png';
import imageTwoRetina from 'marketing-website/media/images/pages/features/handoff/imageTwo@2x.jpg';
import inspectorRetina from 'marketing-website/media/images/pages/features/handoff/inspector@2x.png';
import cssBarRetina from 'marketing-website/media/images/pages/features/handoff/cssBar@2x.png';
import backPanelRetina from 'marketing-website/media/images/pages/features/handoff/backPanel@2x.png';
import cssPanelRetina from 'marketing-website/media/images/pages/features/handoff/cssPanel@2x.png';
import cssFallbackRetina from 'marketing-website/media/images/pages/features/handoff/cssFallback@2x.jpg';
import designWatchRetina from 'marketing-website/media/images/pages/features/handoff/designWatch@2x.jpg';
import browserRetina from 'marketing-website/media/images/pages/features/handoff/browser@2x.jpg';
import handoffArtworkRetina from 'marketing-website/media/images/pages/features/handoff/handoffArtwork@2x.jpg';
import assetsFallbackRetina from 'marketing-website/media/images/pages/features/handoff/assetsFallback@2x.png';

const assets = {
  avatar: {
    alt: '',
    src: avatarRetina,
    maxWidth: 312,
  },
  black: {
    alt: '',
    src: blackRetina,
    maxWidth: 310,
  },
  fills: {
    alt: '',
    src: fillsRetina,
    maxWidth: 240,
  },
  assetsBlock: [
    {
      alt: '',
      id: 0,
      src: imageOneRetina,
    },
    {
      alt: '',
      id: 1,
      src: imageTwoRetina,
    },
    {
      alt: '',
      id: 2,
      src: imageThreeRetina,
    },
  ],
  inspector: {
    alt: '',
    src: inspectorRetina,
  },
  cssBar: {
    alt: '',
    src: cssBarRetina,
    maxWidth: 246,
  },
  backPanel: {
    alt: '',
    src: backPanelRetina,
  },
  cssPanel: {
    alt: '',
    src: cssPanelRetina,
  },
  designWatch: {
    alt: '',
    src: designWatchRetina,
  },
  browser: {
    alt: '',
    src: browserRetina,
  },
  handoffArtwork: {
    alt: '',
    src: handoffArtworkRetina,
    maxWidth: 562,
  },
  assetsFallback: {
    alt: '',
    src: assetsFallbackRetina,
  },
  cssFallback: {
    alt: '',
    maxWidth: 540,
    src: cssFallbackRetina,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/features/handoff/assets.js